<div class="d-flex justify-content-between align-items-center">
  <button class="pay-button btn btn-primary" (click)="onSubmit()" [disabled]="buttonDisabled()">
    <span class="p-2">{{ "payment.pay" | translate }}</span>
  </button>
</div>
